import { observable } from "mobx";
import type { IBankAccount } from "./types";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CounterpartyBankAccountResponse implements IBankAccount {
  /**
   * Account number according to type of format
   */
  @observable
  accountNumber?: string;

  /**
   * Identification of bank
   */
  @observable
  bank?: string;
}
